<template>
    <div class="simulate">
        <div class="recommend-account-opening-box">
            <!-- <div><img class="compnay-default-icon" alt="" src="./images/logo.png"></div> -->
            <div class="compnay-text-icon-box"><img class="compnay-text-icon" alt="" src="./images/bg.png">
            <div id="accountApply" v-show="accountApply == 0 || accountApply == 3">
              <!-- <div class="recommend-account-text">赶紧输入信息，领取资格吧</div> -->
              <div class="input-name">
                <img class="input-img" src="./images/user.png" alt="">
                <input type="text" name="" id="clientName" v-model="clientName" placeholder="请输入姓名" @input="checkInput">
              </div>
              <div class="input-name">
                <img class="input-img" src="./images/phone.png" alt="">
                <input type="tel" id="mobile" maxlength="11" name="phone" v-model="tel" placeholder="请输入手机号码" >
              </div>
              <div class="input-name">
                <img class="input-img" src="./images/message.png" alt="">
                <input type="tel" name="" id="verifyCode" v-model="verifyCode" >
                <button type="button" id="getyzm" class="code-button"  @click="getyzm" v-show="getYZM">获取验证码</button>
                <div class="yzmbutton code-button" id="cxhq" v-show="!getYZM">重新获取{{timeText}}s</div>
              </div>
              <!-- <div class="submit-text">申请成功后，请留意查收开户操作指引短信,</div> -->
              <!-- <div class="submit-text">并下载东航金融App完成开户。</div> -->
              <div class="submit"><button type="button" class="submit-button" @click="apply">立即申请</button></div>
              <div class="submit-text mtb-10">申请成功后请安装东航金融App进行模拟交易</div>
            </div>
            <div id="accountApplyShow" v-show="accountApply == 1 || accountApply == 2">
              <div class="success-icon-box">
                <img v-if="accountApply == 1" src="./images/success.png" class="success-icon" alt="" >
                <img v-if="accountApply == 2" src="./images/fail.png" class="success-icon" alt="">
               </div>
              <!-- <div class="success-text">您已申请成功</div> -->
              <div class="apply-text">{{applyText}}</div>
            </div>
            </div>
            <div class="dowload-phone-icon">
                <a target="_blank" @click="Download"><img class="phone-icon-img phone-icon-img-ios" src="./images/ios.png" alt=""></a>

              <a target="_blank" @click="Download"><img class="phone-icon-img phone-icon-img-android" src="./images/android.png" alt=""></a>
             </div>
        </div>
        <div id="toast" v-show="toastShow">
          {{toastText}}
        </div>
    </div>
</template>
<script>
/* eslint-disable */
import ajax from '@/common/ajax/ajax'
export default {
    data(){
        return {
            accountApply: 0, //0 未申请，1 成功， 2 失败 , 3 申请中
            getYZM: true,
            toastShow: false,
            tel:'',
            verifyCode:'',
            clientName:'',
            timeText:30,
            toastText:'请求失败，请稍后再试！',
            brokerSec:'',
            proID:'',
            applyText:""
        }
    },
    created(){
        this.getAppParams()
        this.judgePhoneType()
    },
    mounted(){},
    methods:{
      Download(){
        this.$router.push('/download')
      },
      getAppParams(){
          let url = window.location.href; //获取url中"?"符后的字串
          const index=url.lastIndexOf("\?");
          const urlSplice =  url.substring(index+1,url.length);
        console.log(urlSplice,'urlSplice');
        const strs = urlSplice.split("&"); //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
        const obj ={}
        strs.map(el=>{
            const indexEl=el.lastIndexOf("\=");
            const urlSpliceEl =  el.substring(indexEl+1,el.length);
            const urlSpliceElKey =  el.substring(0,indexEl);
            const objKeyValue = urlSpliceEl
            const objKey = urlSpliceElKey
            if(objKey === 'brokerSec'){
                this.brokerSec = decodeURI(`${objKeyValue}`)
            } else
            if(objKey === 'proID'){
                this.proID = objKeyValue
            }
        })
        console.log(strs,'strs');
        // alert(strs[1]);   //直接弹出第一个参数 （如果有多个参数 还要进行循环的）
      },
      judgePhoneType(){
                //手机系统类型
                var isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if(isiOS){
                    var system = "IOS";
                }else{
                    var system = "Android";
                }
                //浏览器判断
                var ua = navigator.userAgent.toLowerCase();
                var btype;
                if(ua.match(/MicroMessenger\/[0-9]/i)){
                    btype = "微信";
                }else if(ua.match(/QQ\/[0-9]/i)){
                    btype = "QQ";
                }else if(ua.indexOf('mqqbrowser')> -1){
                    btype = "QQ浏览器";
                }else if(ua.indexOf('opera')> -1){
                    btype = "Opera浏览器";
                }else if(ua.indexOf('ucbrowser')> -1){
                    btype = "UC浏览器";
                }else if(ua.indexOf('baiduboxapp')> -1){
                    btype = "百度浏览器";
                }else if(ua.indexOf('chrome')> -1){
                    btype = "chrome浏览器";
                }else if(ua.indexOf('safari')> -1){
                    btype = "Safari浏览器";
                }else if(ua.indexOf('firefox')> -1){
                    btype = "Firefox浏览器";
                }else{
                    btype = "其它";
                }
                setTimeout(()=> {
                    var repo = "QiniuPandoraQiniuPandora";
                    var token = "TwFQY3_TmvcIpTqfFW4W6fCfFwN1XiUpJdtCYPhW:yOTlzTrM5VKFHN1L_yyxYMcVLBM=:eyJyZXNvdXJjZSI6Ii92Mi9yZXBvcy9hcHBOZXcvZGF0YSIsImV4cGlyZXMiOjE4Nzc1Nzg5ODIsImNvbnRlbnRNRDUiOiIiLCJjb250ZW50VHlwZSI6InRleHQvcGxhaW4iLCJoZWFkZXJzIjoiIiwibWV0aG9kIjoiUE9TVCJ9";
                    var data = [{"system": system, "type": btype,"ctype":"老访问"}];
                    // QiniuPandora.pushToPandoraPipeline(repo, token, data);
                }, 200);
        },
      getyzm(){
            console.log(this.tel,'tel');
            if(!this.checkMobile()){
                this.toast("请填写正确的手机号！");
                return;
            }
            this.getYZM = false

            let i = 30;
            const clock = setInterval(()=>{
            i--;
            if(i == 0){
                i = 30;
                clearInterval(clock);
                this.getYZM = true
            }
            this.timeText = i
        },1000)
            const senddata = {
                mobile: this.tel,
                type:1003
            }
            ajax.sendVerifyCode(senddata).then(res=>{
                this.toast(res.data.resultMessage);
            }).catch(()=>{
                this.toast("请求失败，请稍后再试！");
            })
     },
     checkMobile() {
       let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
       if( !reg.test(this.tel)) {
         return false
       }
       return true
     },
     checkInput() {
       let reg = /[^\u4E00-\u9FA5\u25CF\u00B7\d]/gi
       this.clientName = this.clientName.replace(reg, '')
     },
     checkName() {
         if(!this.clientName) {
           this.toast("请输入姓名！")
           return false
         }
         this.clientName = this.clientName.replace(/\s/g, '')
         let reg =  /[^\u4E00-\u9FA5\u25CF\u00B7\d]/gi
         /* if(this.clientName.length > 10 || this.clientName.length < 2) {
           this.toast("真实姓名需在2-10位！")
           return false
         } */
         if(reg.test(this.clientName)) {
           this.toast("请输入姓名！")
           return false
         }
         return true
      },
      apply(){
            //申请中，再点击不提交
            if(this.accountApply == '3') {return}

            if(!this.checkName()){
                return;
            }
            if(!this.checkMobile()){
                this.toast("请填写正确的手机号！");
                return;
            }

            if(!this.verifyCode){
                this.toast("请填写验证码！");
                return;
            }

            this.proID = this.$route.query.proID
            var vo = {
                phoneNumber: this.tel,
                verifyCode: this.verifyCode,
                clientName: this.clientName,
                source: this.proID
            }
            this.accountApply = 3
            ajax.applicationAccountSimnow(vo).then(res=>{
                if(res.data.resultStatus === '0'){
                    this.accountApply = 1
                    this.applyText = res.data.resultMessage
                } else if(res.data.resultStatus === '-2012'){
                    this.accountApply = 2
                    this.applyText = res.data.resultMessage
                }else {
                    this.accountApply = 0
                    this.toast(res.data.resultMessage);
                }
            }).catch(()=>{
                this.accountApply = 0
                this.toast("请求失败，请稍后再试！");
            })
        },
        toast(text) {
            this.toastShow = true
            this.toastText = text;
            setTimeout(()=> {
            this.toastShow = false
            } ,2000)
        }
    }
}
</script>
<style src="./index.css" scoped></style>



// WEBPACK FOOTER //
// NewSimulate.vue?1d6e04ed